import { Answer } from './answer.model';

export class AnswerRequest {
  responses: Answer[] = [];
}



// WEBPACK FOOTER //
// ./src/app/models/questionnaire/answerRequest.model.ts